import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthConfig } from '@lockton-apps/shared/interfaces';

import { AuthService } from './auth.service';
import { AUTH_CONFIG, DEFAULT_AUTH_CONFIG } from '../auth-config';
import { some } from 'lodash';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  apiUrls: string[];

  constructor(
    private authService: AuthService,
    @Optional() @Inject(AUTH_CONFIG) authConfig: AuthConfig
  ) {
    this.apiUrls = authConfig
      ? authConfig.apiUrls
      : DEFAULT_AUTH_CONFIG.apiUrls;
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();
    const isAPI = some(this.apiUrls, (url) => request.url.includes(url));

    const passedRequest =
      isAPI && token
        ? request.clone({
            headers: request.headers.set('Authorization', `Bearer ${token}`),
          })
        : request;
    return next.handle(passedRequest);
  }
}
